import { FC, ChangeEvent } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import { formatCurrencyDecimals, formatNumber } from 'utils/formats';
import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';

import SellUnitsStepper from './SellUnitsStepper';

type CustomUnitsInputProps = {
  value: number;
  max: number;
  netPreview: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};

const CustomUnitsInput: FC<CustomUnitsInputProps> = ({
  value,
  max,
  netPreview,
  onChange,
  disabled,
}) => {
  const { t } = useTranslate();

  return (
    <div>
      <label className="form-label d-flex align-items-center fs-14px fw-medium text-secondary mb-2">
        {t('IncentivesMarketSellCustomUnitsLabel')}
        <IconTooltip
          id="incentive-offer-sell-custom-units-fifo-tooltip"
          tooltip={t('IncentivesMarketSellUnitsFifoTooltip')}
          place="top"
          className="text-soft"
          wrapperClassName="d-inline ml-1"
        />
      </label>

      <div className="d-flex align-items-center justify-content-between mb-3">
        <SellUnitsStepper
          value={value}
          max={max}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="fs-14px fw-semibold text-secondary tnum">
          {formatCurrencyDecimals(netPreview)}
        </span>
      </div>

      <div className="d-flex align-items-center">
        <input
          type="range"
          min={0}
          max={max}
          value={value}
          disabled={disabled}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(Number(e.target.value))
          }
          className="incentive-offer-sell-units-panel__range"
        />
        <span className="flex-shrink-0 text-right fs-12px text-soft tnum">
          {t('IncentivesMarketSellCustomUnitsMax', {
            max: formatNumber(max),
          })}
        </span>
      </div>

      <p className="form-note mt-2 mb-0">
        {t('IncentivesMarketSellCustomUnitsFifoHint')}
      </p>
    </div>
  );
};

export default CustomUnitsInput;
